import React, { useState, useEffect, useRef } from "react";
import { Modal, Header, Image, Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  addDataSet,
  getApprovedDatasets,
  getDocumentSuccess,
  AddRequestSuccess,
  DatasetUsersDataSuccess,
  ListApprovedSuccess,
} from "../../actions/dataConsoleAction";
import TableRowsLoaderApprovedDataset from "../Pagination/TableRowsLoaderApprovedDataset";
import PaginationApprovedDataset from "../Pagination/PaginationApprovedDataset";
import "../../styles/Dataset.css";
import Loader from "../../components/Loader";
import MobileApprovedDataset from "./MobileApprovedDataset";

const ApprovedDataset = ({ setDatsetCount, showToaster, dataFromChild }) => {
  const dispatch = useDispatch();
  const { loading, addDataSetResponseData, error } = useSelector(
    (state) => state.addDatasetReducer || {}
  );
  const { response, approvedDatasetStatus } = useSelector(
    (state) => state.getDatasetApprovedReducer || {}
  );
  const [open, setOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [lengthError, setLengthError] = useState(true);
  const [specialChar, setSpecialChar] = useState(true);
  const [datasetExistError, setDatasetExistError] = useState("");
  const [data, setData] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const isMounted = useRef(true);
  const [filterDocdata, setfilterDocdata] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [LoaderFlag, setLoaderFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getDataSet = () => {
    try {
      const params = {
        userAccessType: "Approved",
      };
      dispatch(getApprovedDatasets(params));
      setfilterDocdata(true);
      setLoadingData(false);
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  useEffect(() => {
    // Simulate fetching data with a timeout
    // Replace this with your actual data fetching logic
    setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Adjust the timeout duration as needed
  }, []);

  useEffect(() => {
    if (isMounted.current || deleteStatus) {
      getDataSet();
      isMounted.current = false;
    }
  }, [dispatch]);

  useEffect(() => {
    if (response && approvedDatasetStatus === 200)
      if (response.length > 0) {
        setLoadingData(false);
        if (dataFromChild) {
          const fitleredData = response.filter((results) => {
            return results.datasetName
              .toString()
              .toLowerCase()
              .includes(dataFromChild);
          });
          if (fitleredData.length > 0) {
            setData(fitleredData);
          } else {
            setData([]);
          }
        } else {
          setData(response);
        }
      } else {
        setData(response);
      }
  }, [dataFromChild, response, approvedDatasetStatus]);

  useEffect(() => {
    if (response && approvedDatasetStatus === 200) {
      setIsButtonEnabled(false);
      setDatsetCount(response.length);
      if (response.length > 0) {
        setData(response);
        //dispatch(ListApprovedSuccess());
      }
    }
  }, [response, approvedDatasetStatus]);

  const columns = [
    { id: "datasetName", label: "Dataset name" },
    { id: "files", label: "Documents" },
  ];

  const columnsSkelton = [
    { id: "datasetName", label: "Dataset name" },
    { id: "files", label: "Documents" },
  ];

  const handleClose = () => {
    setOpen(false);
    setDatasetExistError("");
    setInputValue("");
    setSpecialChar(true);
  };
  const handleCloseFlag = () => {
    setOpen(false);
    setDatasetExistError("");
    setSpecialChar(true);
  };

  const handleDataSet = async () => {
    if (isButtonEnabled) {
      const formDataObject = new FormData();
      formDataObject.append(
        "json",
        JSON.stringify({
          datasetname: inputValue,
          isReferenceDataset: false // Regular datasets are not reference datasets by default
        })
      );
      dispatch(addDataSet(formDataObject));
      handleCloseFlag();
      setLoaderFlag(true);
      setfilterDocdata(true);
      setSpecialChar(true);
    }
  };

  const handleChange = (event) => {
    setDatasetExistError("");
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^\w\s]/gi, "");
    setInputValue(value);
    setSpecialChar(value !== sanitizedValue ? false : true);
    setLengthError(sanitizedValue.length > 50 ? false : true);

    lengthError && value == sanitizedValue && sanitizedValue.length > 0
      ? setIsButtonEnabled(true)
      : setIsButtonEnabled(false);
  };

  const actions = [
    { key: "text", text: "Text Only", value: "text" },
    { key: "file", text: "File Only", value: "file" },
  ];

  const navigate = useNavigate();
  const otherdataset = async (path) => {
    console.log("path", path);
    navigate("/" + path);
  };
  const location = useLocation();
  return (
    <div>
      <div className="mobile-dataset-container">
        <div className="mobile-dataconsole-header dataset-nav-box">
          <div
            className={
              location.pathname === "/data-sets"
                ? "mobile-dataset-header-left"
                : ""
            }
          >
            <span onClick={() => otherdataset("data-sets")}>
              Approved Dataset
              {location.pathname === "/data-sets" && !isLoading
                ? `(${response.length})`
                : ""}
            </span>
          </div>
          <div
            className={
              location.pathname === "/other-datasets"
                ? "mobile-dataset-header-left"
                : ""
            }
          >
            <span onClick={() => otherdataset("other-datasets")}>
              Other Dataset
            </span>{" "}
            <span></span>
          </div>
        </div>
      </div>
      {loadingData ? (
        <TableRowsLoaderApprovedDataset columns={columnsSkelton} rowsNum={10} />
      ) : data.length > 0 && !isMounted.current && !isLoading ? (
        <>
          <div className="desktop-dataset-container">
            <PaginationApprovedDataset
              columns={columns}
              data={data}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
            />
          </div>

          <div className="mobile-dataset-mobile-box">
            <MobileApprovedDataset
              data={data}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
            />
          </div>
        </>
      ) : (
        <>
          <div className="emptyContainer">
            <Image src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available </span>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default ApprovedDataset;
